var Pagination = /** @class */ (function () {
    function Pagination() {
        this.items = [];
        this.page = 0;
    }
    Pagination.prototype.getDate = function () {
        return this.items[this.page - 1];
    };
    Object.defineProperty(Pagination.prototype, "pageCount", {
        get: function () {
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pagination.prototype, "pages", {
        get: function () {
            return this.items;
        },
        enumerable: true,
        configurable: true
    });
    Pagination.getNew = function (data) {
        var p = new Pagination();
        Object.getOwnPropertyNames(p).forEach(function (key) {
            if (typeof data[key] !== 'undefined') {
                p[key] = data[key];
            }
        });
        return p;
    };
    Pagination.prototype.fill = function (data) {
        var _this = this;
        Object.getOwnPropertyNames(this).forEach(function (key) {
            if (typeof data[key] !== 'undefined') {
                _this[key] = data[key];
            }
        });
    };
    return Pagination;
}());
export { Pagination };
